import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export default function Blogs() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const apiBase = process.env.REACT_APP_API_BASE || ''; // keep empty for same-origin

  // Call into the Django backend API (served under /webapi/ on fortiteam.real-tech.org)
  // This returns the list of blog posts as JSON from BlogPostViewSet
  useEffect(() => {
    const ac = new AbortController();
    fetch(`${apiBase}/webapi/content/blogs/`, {
      headers: { Accept: 'application/json' },
      signal: ac.signal,
    })
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then((data) => {
        setPosts(Array.isArray(data) ? data : data.results ?? []);
      })
      .catch((err) => {
        if (err.name !== 'AbortError') {
          console.error('Error fetching blog posts:', err);
        }
      })
      .finally(() => setLoading(false));
    return () => ac.abort();
  }, [apiBase]);

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Blogs",
    "name": "FortiTeam Blogs",
    "url": "https://www.homecarechecks.com/blogs",
    "description": "Learn how to protect your clients, stay compliant, and simplify caregiver screening. Explore blog posts for agency owners, HR staff, and healthcare leaders.",
    "blogPost": posts.map((post) => ({
      "@type": "BlogPosting",
      "headline": post.Title,
      "url": `https://www.homecarechecks.com/blogs/${post.Slug}`,
      "description": post.MetaDescription,
      "author": { "@type": "Organization", "name": "FortiTeam" },
      "publisher": {
        "@type": "Organization",
        "name": "FortiTeam",
        "logo": {
          "@type": "ImageObject",
          "url": "https://homecarechecks.com/assets/logos/logo.png"
        }
      }
    }))
  };

  const filteredPosts = posts.filter(post =>
    (post.Title || '').toLowerCase().includes(searchQuery.toLowerCase()) ||
    (post.MetaDescription || '').toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <main>
      <Header
        title="Compliance Tips & Background Check Best Practices | FortiTeam Blog"
        description="Learn how to protect your clients, stay compliant, and simplify caregiver screening. Explore blog posts for agency owners, HR staff, and healthcare leaders."
        structuredData={structuredData}
      />

      <HeroSection
        heading="Stay Compliant by Learning the Latest Topics"
        subheading="Enhance Your Background Check Process"
        tagline="Search Our Blog"
      />

      <section className="features">
        <input
          id="blogSearch"
          type="text"
          placeholder="Search blog topics..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />

        {loading && <p>Loading...</p>}
        {!loading && filteredPosts.length === 0 && <p>No blog posts found.</p>}

        {filteredPosts.map((post) => (
          <div key={post.id ?? post.Slug} className="blog-post">
            <h2>
              <Link to={`/blogs/${post.Slug}`} state={{ post }}>
                {post.Title}
              </Link>
            </h2>
          </div>
        ))}
      </section>
    </main>
  );
}
